class RaceCountdown extends window.BAO.CustomElement() {
  connectedCallback () {
    super.connectedCallback()

    this.setupCountdown()

    // eslint-disable-next-line compat/compat
    this.observer = new IntersectionObserver(this.onEntry.bind(this), {
      rootMargin: '0px 0px -100px 0px',
    })
    this.observer.observe(this.els.timer.element)
  }

  setupCountdown () {
    const second = 1000
    const minute = second * 60
    const hour = minute * 60
    const day = hour * 24

    const countdownFromTime = new Date(
      `${this.dataset.displayDate} 00:00`,
    ).getTime()
    const countdownRaceTime = new Date(
      `${this.dataset.raceDate} ${this.dataset.raceTime}`,
    ).getTime()

    this.countdownInterval = setInterval(() => {
      this.countdownDifference = countdownRaceTime - this.getUkTime

      if (this.countdownDifference < 1) {
        this.countdownComplete()
      } else {
        const timeRemaining = {
          days: Math.floor(this.countdownDifference / day),
          hours: Math.floor((this.countdownDifference % day) / hour),
          minutes: Math.floor((this.countdownDifference % hour) / minute),
          seconds: Math.floor((this.countdownDifference % minute) / second),
        }

        this.els.days.element.innerText = timeRemaining.days.toLocaleString(
          undefined,
          { minimumIntegerDigits: 2 },
        )
        this.els.hours.element.innerText = timeRemaining.hours.toLocaleString(
          undefined,
          { minimumIntegerDigits: 2 },
        )
        this.els.minutes.element.innerText = timeRemaining.minutes.toLocaleString(
          undefined,
          { minimumIntegerDigits: 2 },
        )
        this.els.seconds.element.innerText = timeRemaining.seconds.toLocaleString(
          undefined,
          { minimumIntegerDigits: 2 },
        )

        this.els.daystext.element.innerText =
          timeRemaining.days === 1
            ? this.els.daystext.element.dataset.singular
            : this.els.daystext.element.dataset.plural
        this.els.hourstext.element.innerText =
          timeRemaining.hours === 1
            ? this.els.hourstext.element.dataset.singular
            : this.els.hourstext.element.dataset.plural
        this.els.minutestext.element.innerText =
          timeRemaining.minutes === 1
            ? this.els.minutestext.element.dataset.singular
            : this.els.minutestext.element.dataset.plural
        this.els.secondstext.element.innerText =
          timeRemaining.seconds === 1
            ? this.els.secondstext.element.dataset.singular
            : this.els.secondstext.element.dataset.plural

        const totalTime = countdownRaceTime - countdownFromTime
        const totalRemainingTime = this.getUkTime - countdownFromTime

        const remainingPercentage = (totalRemainingTime / totalTime) * 100

        const displayedPercentage =
          remainingPercentage > 100
            ? 100
            : remainingPercentage < 0
              ? 0
              : remainingPercentage

        this.style.setProperty(
          '--BarScale',
          `${parseInt(displayedPercentage)}%`,
        )

        if (this.els?.dot?.exists) {
          this.els.dot.element.style.setProperty(
            '--DotColor',
            displayedPercentage === 100 ? 'var(--Color_PetronasTeal)' : '#fff',
          )
        }
      }
    }, second)
  }

  countdownComplete () {
    this.els.days.element.innerText = `00`
    this.els.hours.element.innerText = `00`
    this.els.minutes.element.innerText = `00`
    this.els.seconds.element.innerText = `00`

    this.els.daystext.element.innerText = this.els.daystext.element.dataset.plural
    this.els.hourstext.element.innerText = this.els.hourstext.element.dataset.plural
    this.els.minutestext.element.innerText = this.els.minutestext.element.dataset.plural
    this.els.secondstext.element.innerText = this.els.secondstext.element.dataset.plural

    this.style.setProperty('--BarScale', `100%`)

    clearInterval(this.countdownInterval)

    if (this.els?.dot?.exists) {
      this.els.dot.element.style.setProperty(
        '--DotColor',
        'var(--Color_PetronasTeal)',
      )
    }
  }

  get getUkTime () {
    return new Date(
      Date().toLocaleString('en-US', { timeZone: 'Europe/London' }),
    ).getTime()
  }

  onEntry ([entry], observer) {
    if (!entry.isIntersecting) return

    this.classList.add('sec-RaceCountdown-active')
    observer.unobserve(this.els.timer.element)
  }
}

if (!customElements.get('race-countdown')) {
  customElements.define('race-countdown', RaceCountdown)
}
